import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    fetchSpecificData,
    fetchSpecificDataSuccess,
    fetchSpecificDataFail,
    resetState
} from './dossier.action';
import { Category, Dossier } from './dossier.model';

export interface DossierRecordsState {
    listData: Dossier[];
    singleData: Dossier;
    loading: boolean;
    error: any;
    total: number;
    dossierData: {countryList: any[], clubs: any[], categories: Category[]}
}

export const initialState: DossierRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    dossierData: {countryList:[], clubs:[], categories: []}
};


export const DossierRecordReducer = createReducer(

    initialState,
    
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    
    on(fetchSpecificData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSpecificDataSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchSpecificDataFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),


    on(fetchSingleRecordSuccess, (state, { singleData, dossierData }) => {
        return { ...state, singleData, dossierData, loading: false, error: null };
    }),
    on(resetState, () => initialState)  // Reset action handler
    
);